<div
  class="location-tile"
  (click)="handleSelect()"
  (keyup.enter)="handleSelect()"
  [ngClass]="{'selected': isSelected, 'clickable': isEditMode}"
  tabindex="0"
>
  <div class="d-flex align-items-center">
    <img
      *ngIf="!isChangeMode && (isPreferred || isEditMode)"
      [src]="getHeartPath"
      alt="Heart Icon"
      height="14"
      class="mr-2"
    >
    <img
      *ngIf="isChangeMode"
      [src]="getCheckPath"
      tabindex="0"
      alt="Check Icon"
      height="16"
      class="mr-2"
    >
    <span
      class="oswald title"
      [ngClass]="{'primary': isNameActive, 'teal': !isNameActive}"
    >{{ locationData?.name }}</span>
    <img
      *ngIf="isChangeMode && isPreferred"
      [src]="ACTIVE_HEART_PATH"
      alt="Heart Icon"
      height="14"
      style="margin-left: auto;"
    >
  </div>
  <div
    *ngIf="isEditMode"
    class="mt-2 ml-4"
  >
    <span class="lato bold teal addr-1">{{ locationData?.address1 }}</span><br>
    <div
      *ngIf="locationData?.address2"
      class="lato bold teal"
    >{{ locationData?.address2 }}</div>
    <div class="lato">{{ locationData?.city + ', ' + locationData?.state + ' ' + locationData?.zipcode }}</div>
  </div>
  <div
    *ngIf="!isEditMode"
    class="d-flex align-items-center mt-2"
  >
    <div class="mr-auto">
      <span class="lato bold teal addr-1">{{ locationData?.address1 }}</span><br>
      <div
        *ngIf="locationData?.address2"
        class="lato bold teal"
      >{{ locationData?.address2 }}</div>
      <div class="lato">{{ locationData?.city + ', ' + locationData?.state + ' ' + locationData?.zipcode }}</div>
    </div>
    <a
      [href]="googleMapsService.getDirectionsUrl(
        locationData?.address1 + ' ' + locationData?.address2 + ', ' +
        locationData?.city + ', ' + locationData?.state + ' ' + locationData?.zipcode
      )"
      target="_blank"
    >
      <img
        src="assets/svg/ico_location.svg"
        alt="Location Pin Icon"
        height="24"
      >
    </a>
  </div>
  <div
    *ngIf="!isEditMode"
    class="row no-gutters"
    style="margin-top: 0.688rem;"
  >
    <div
      *ngIf="locationData?.telephone"
      class="col"
      [ngClass]="{'mr-1': locationData?.websiteUrl}"
    >
      <a
        role="button"
        [href]="'tel:' + locationData?.telephone"
        class="footer-link-container d-flex justify-content-center align-items-center text-decoration-none"
      >
        <img
          src="assets/images/ico_phone_red.png"
          alt="Phone Icon"
          height="16"
          style="margin-right: 0.375rem;"
        >
        <span class="lato bold critical footer-link">{{ locationData?.telephone | phoneNumber }}</span>
      </a>
    </div>
    <div
      *ngIf="locationData?.websiteUrl"
      class="col"
      [ngClass]="{'ml-1': locationData?.telephone}"
    >
      <a
        role="button"
        [href]="locationData?.websiteUrl"
        target="_blank"
        class="footer-link-container d-flex justify-content-center align-items-center text-decoration-none"
      >
        <img
          src="assets/svg/ico_global_grid.svg"
          alt="Globe Icon"
          height="16"
          style="margin-right: 0.375rem;"
        >
        <span class="lato bold teal footer-link">Visit Website</span>
      </a>
    </div>
  </div>
</div>
